import React, { useEffect, useRef, useState } from "react";
import styles from "./PDCModal.module.css";
import CloseIcon from "@mui/icons-material/Close";
import SingleDocModal from "../SingleDocModal";
import { url } from "../../../../../../App";
import axios from "axios";
import Cookies from "js-cookie";
import PDFViewer from "../../PDFViewer/PDFViewer";
import { toast } from "react-toastify";
import { MdDeleteForever } from "react-icons/md";
import { FaImage } from "react-icons/fa";
import { IoMdDownload } from "react-icons/io";

const PDCModal = ({ loanId, closeModal }) => {
  const [pdcVal, setPdcVal] = useState({
    bankName: "",
    bankBranch: "",
    chequeDate: "",
    amount: "",
    chequeNo: "",
    chequePurpose: "EMI",
    imageFormat: "",
    imageBase64: "",
  });

  const [docModalProps, setDocModalProps] = useState({
    doc: "",
    format: "",
  });

  const [docModal, setDocModal] = useState(false);
  const [pdfModal, setPdfModal] = useState(false);

  const [pdCount, setPdCount] = useState(0);

  const [pdcArr, setPdcArr] = useState([]);
  const fetchData = async () => {
    const req = {
      loanId: loanId,
      token: Cookies.get("Token"),
      email: Cookies.get("Email"),
    };
    try {
      const { data } = await axios.post(url + "/loan/view/pdc/data", req);
      if (!data.auth) {
        console.log(data.message);
        if (data.message === "No data found.") {
          setPdcArr([]);
        }
        return;
      }
      setPdCount(data.pdcCount);
      setPdcArr(data.data);
    } catch (error) {
      console.log(error.response.status);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const uploadRef = useRef(null);
  const handleInputChange = (state) => {
    return (e) => {
      setPdcVal((prevState) => ({
        ...prevState,
        [state]: e.target.value,
      }));
    };
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    setPdcVal((prevState) => ({
      ...prevState,
      imageFormat: file.name.split(".")[1],
    }));
    const reader = new FileReader();

    reader.onload = () => {
      const base64string = reader.result.split(",")[1];
      setPdcVal((prevState) => ({
        ...prevState,
        imageBase64: base64string,
      }));
    };
    reader.readAsDataURL(file);
  };

  const addFieldHandler = async () => {
    // const emptyField = Object.values(pdcVal).some(
    //   (field) => field.length === 0
    // );
    // if (emptyField) {
    //   toast.error("Please ensure no fields are empty and image is uploaded ");
    //   return;
    // }
    const request = {
      token: Cookies.get("Token"),
      email: Cookies.get("Email"),
      loanId: loanId,
      srNo: pdCount + 1,
      docType: pdcVal.imageFormat,
      chequeData: pdcVal.imageBase64,
      bankName: pdcVal.bankName,
      bankBranchName: pdcVal.bankBranch,
      chequeNo: pdcVal.chequeNo,
      amount: pdcVal.amount,
      chequeDate: pdcVal.chequeDate,
      chequePurpose: pdcVal.chequePurpose,
    };
    try {
      await axios.post(url + "/loan/add/pdc/data", request);
      fetchData();
    } catch (err) {
      console.log(err.response.data);
      console.log(err.response.status);
      toast.error(err.response.data.message);
    }
  };

  const deleteFileHandler = async (id) => {
    const request = {
      token: Cookies.get("Token"),
      email: Cookies.get("Email"),
      loanId: loanId,
      srNo: id,
    };
    try {
      const { data } = await axios.post(url + "/loan/delete/pdc/data", request);
      console.log(data);
      fetchData();
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  const handleViewImage = (format, base64) => {
    if (format === "pdf") {
      setPdfModal(true);
    } else {
      setDocModal(true);
    }
    setDocModalProps((prevState) => ({
      ...prevState,
      doc: base64,
      format: format,
    }));
  };

  const closeDocModal = () => {
    setDocModal(false);
  };

  const downloadFileHandler = (format, base64) => {
    let type;
    if (format === "pdf") {
      type = "pdf";
    } else {
      type = "image";
    }

    const linkSource = `data:${type}/${format};base64,${base64}`;
    const downloadLink = document.createElement("a");
    const fileName = `${loanId} PDC.${format}`;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  return (
    <section>
      <div className={styles.pdcModal}>
        <div className={styles.pdcModalOverlay}>
          <div className={styles.pdcModalContent}>
            {docModal && (
              <SingleDocModal
                closeModal={closeDocModal}
                doc={docModalProps.doc}
                docType={docModalProps.format}
              />
            )}
            {pdfModal && (
              <PDFViewer
                url={`data:application/pdf;base64,${docModalProps.doc}`}
                closeModal={() => setPdfModal(false)}
                docType={docModalProps.format}
              />
            )}
            <div className={styles.topBar}>
              <div>
                <h2>PDC Detalis</h2>
              </div>

              <CloseIcon className={styles.CloseIcon} onClick={closeModal} />
            </div>
            <div className={styles.tableDiv}>
              <table className={styles.customTable}>
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Bank Name</th>
                    <th>Bank Branch</th>
                    <th>Amount</th>
                    <th>Cheque Date</th>
                    <th>Cheque No.</th>
                    <th>Cheque Purpose</th>
                    <th>Cheque Image</th>
                    <th>Actions</th>
                  </tr>
                  {pdcArr?.length > 0
                    ? pdcArr.map((field) => {
                        const date = field?.chequeDate?.split("T")[0];
                        return (
                          <tr key={field.srNo}>
                            <td>{field.srNo}</td>
                            <td>{field.bankName}</td>
                            <td>{field.bankBranchName}</td>
                            <td>{field.amount}</td>
                            <td>{date}</td>
                            <td>{field.chequeNo}</td>
                            <td>{field.chequePurpose}</td>
                            <td>
                              <div className={styles.actions}>
                                <p
                                  onClick={() =>
                                    handleViewImage(
                                      field.chequeDocType,
                                      field.chequeData
                                    )
                                  }
                                >
                                  <FaImage
                                    size={24}
                                    color="rgba(0, 94, 202, 0.952)"
                                    cursor={"pointer"}
                                  />
                                </p>
                                <p
                                  onClick={() =>
                                    downloadFileHandler(
                                      field.chequeDocType,
                                      field.chequeData
                                    )
                                  }
                                >
                                  <IoMdDownload
                                    size={24}
                                    color="rgba(0, 94, 202, 0.952)"
                                    cursor={"pointer"}
                                  />
                                </p>
                              </div>
                            </td>
                            <td>
                              <p onClick={() => deleteFileHandler(field.srNo)}>
                                <MdDeleteForever
                                  size={24}
                                  color="red"
                                  cursor={"pointer"}
                                />
                              </p>
                            </td>
                          </tr>
                        );
                      })
                    : null}
                  <tr>
                    {/* {pdCount.length !== 0 ? parseInt(pdCount) + 1 : "1"} */}
                    <td>{pdCount + 1}</td>
                    <td>
                      <input
                        type="text"
                        value={pdcVal.bankName}
                        onChange={handleInputChange("bankName")}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={pdcVal.bankBranch}
                        onChange={handleInputChange("bankBranch")}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        onChange={handleInputChange("amount")}
                        value={pdcVal.amount}
                      />
                    </td>
                    <td>
                      <input
                        type="date"
                        onChange={handleInputChange("chequeDate")}
                        value={pdcVal.chequeDate}
                        inputProps={{
                          max: new Date().toISOString().split("T")[0],
                        }}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        onChange={handleInputChange("chequeNo")}
                        value={pdcVal.chequeNo}
                      />
                    </td>
                    <td>
                      <select
                        onChange={handleInputChange("chequePurpose")}
                        name=""
                        id=""
                        value={pdcVal.chequePurpose}
                      >
                        <option value="EMI">EMI</option>
                        <option value="Pre-EMI">Pre-EMI</option>
                        <option value="PDC">PDC</option>
                        <option value="SPDC">SPDC</option>
                      </select>
                    </td>
                    <td>
                      <input
                        onChange={handleImageUpload}
                        type="file"
                        ref={uploadRef}
                        style={{ display: "none" }}
                      />
                      <button
                        className={styles.upload}
                        onClick={() => uploadRef.current.click()}
                      >
                        Upload
                      </button>
                    </td>
                    <td>
                      <button className={styles.add} onClick={addFieldHandler}>
                        {/* <IoMdAddCircle
                          cursor={"pointer"}
                          size={24}
                          color="rgba(0, 94, 202, 0.952)"
                        /> */}
                        ADD
                      </button>
                    </td>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PDCModal;
